import { render, staticRenderFns } from "./CustomTheme.vue?vue&type=template&id=13a9f875&"
import script from "./CustomTheme.js?vue&type=script&lang=js&"
export * from "./CustomTheme.js?vue&type=script&lang=js&"
import style0 from "./CustomTheme.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VBtn,VCol,VIcon,VLabel})
